import { getCookie } from './cookie.store';
import { CookieTypes } from '../types/cookie-token.type';

export const getSafeKey = (name: string) => {
  const tenantId = getCookie(CookieTypes.TenantId);
  const shopId = getCookie(CookieTypes.ContextShopId);
  return `${tenantId || ''}-${shopId || ''}.${name}`;
};

export const getNamedLocalStorage = (name: string): string | null => {
  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    localStorage.getItem(getSafeKey(name)) !== 'undefined'
  ) {
    return localStorage.getItem(getSafeKey(name));
  }
  return null;
};

export const removeNamedLocalStorage = (name: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.removeItem(getSafeKey(name));
  }
};

export const setNamedLocalStorage = (name: string, updatedResource: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem(getSafeKey(name), updatedResource);
  }
};
